export const apiUrl = `https://api.userfront.com/v0/`;

export const privateIPRegex =
  /((^127\.)|(^10\.)|(^172\.1[6-9]\.)|(^172\.2[0-9]\.)|(^172\.3[0-1]\.)|(^192\.168\.))\d{1,3}\.\d{1,3}/g;
